/* =====================================================================
   QueryKeys centralizados (guía v2 § 10.8)

   Convención:
     queryKeys.<feature>.<resource>            → namespace base
     queryKeys.<feature>.<resource>.list(...)  → listas con args
     queryKeys.<feature>.<resource>.detail(id) → detalle
     queryKeys.<feature>.all                   → invalida todo el feature
===================================================================== */

export const queryKeys = {
  config: {
    all: ['config'] as const,
    questions: ['config', 'questions'] as const,
    scenarios: ['config', 'scenarios'] as const,
    cases: ['config', 'cases'] as const,
    pokemon: ['config', 'pokemon'] as const,
    companies: ['config', 'companies'] as const,
  },
  players: {
    all: ['players'] as const,
    list: () => ['players', 'list'] as const,
    detail: (id: string) => ['players', 'detail', id] as const,
    leaderboard: (limit: number) => ['players', 'leaderboard', limit] as const,
  },
  meta: {
    all: ['meta'] as const,
  },
} as const;
